import React, { useEffect } from 'react';

const GoogleMapComponent = ({ title, desc, url, long, lat }) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (window.google && !window.mapInitialized) {
        window.mapInitialized = true; // Flag to prevent re-initialization

        const map = new google.maps.Map(document.getElementById('map'), {
          center: { lat: parseFloat(lat), lng: parseFloat(long) },
          zoom: 10,
          styles: [
            {
              elementType: 'geometry',
              stylers: [{ color: '#f5f5f5' }],
            },
            {
              elementType: 'labels.icon',
              stylers: [{ visibility: 'off' }],
            },
            {
              elementType: 'labels.text.fill',
              stylers: [{ color: '#616161' }],
            },
            {
              elementType: 'labels.text.stroke',
              stylers: [{ color: '#f5f5f5' }],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#bdbdbd' }],
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [{ color: '#eeeeee' }],
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#757575' }],
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry',
              stylers: [{ color: '#e5e5e5' }],
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#9e9e9e' }],
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [{ color: '#ffffff' }],
            },
            {
              featureType: 'road.arterial',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#757575' }],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [{ color: '#dadada' }],
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#616161' }],
            },
            {
              featureType: 'road.local',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#9e9e9e' }],
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [{ color: '#e5e5e5' }],
            },
            {
              featureType: 'transit.station',
              elementType: 'geometry',
              stylers: [{ color: '#eeeeee' }],
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [{ color: '#c9c9c9' }],
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#9e9e9e' }],
            },
          ],
        });

        const marker = new google.maps.Marker({
          position: { lat: parseFloat(lat), lng: parseFloat(long) },
          map: map,
          title: title,
        });

        const infoWindow = new google.maps.InfoWindow({
          content: `
            <div class="map-wrap">
              <img src="/blogo.png" alt="map"/>
              <h2>${title}</h2>
              <a href="${url}" target="_blank">Get Direction</a>
            </div>
          `,
        });

        infoWindow.open(map, marker);

        marker.addListener('click', () => {
          infoWindow.open(map, marker);
        });
      }
    }
  }, [title, desc, url, long, lat]);

  return <div id="map" style={{ width: '100%', height: '400px' }}></div>;
};

export default GoogleMapComponent;